// Constantes para uso em toda a aplicação

// URL base do site
export const SITE_URL = 'https://webimports.com.br';

// Informações de contato
export const CONTATO = {
  TELEFONE: '+551932060706',
  EMAIL: 'contato@webimports.com.br',
  ENDERECO: 'Rua Tapuru, 25, Alpha Mall / Loja 26, Alphaville',
  CIDADE: 'Campinas',
  ESTADO: 'SP',
  CEP: '13098-322',
  PAIS: 'BR',
  COORDENADAS: {
    LATITUDE: '-22.8305',
    LONGITUDE: '-47.0820'
  }
};

// Categorias de serviços
export const CATEGORIAS = {
  TODOS: 'todos',
  DESENVOLVIMENTO: 'desenvolvimento',
  MANUTENCAO: 'manutencao',
  INFRAESTRUTURA: 'infraestrutura'
};

// Nomes das categorias
export const NOME_CATEGORIAS = {
  [CATEGORIAS.TODOS]: 'Todos',
  [CATEGORIAS.DESENVOLVIMENTO]: 'Desenvolvimento',
  [CATEGORIAS.MANUTENCAO]: 'Manutenção',
  [CATEGORIAS.INFRAESTRUTURA]: 'Infraestrutura'
};

// Lista de serviços
export const SERVICOS = [
  'desenvolvimento-web',
  'desenvolvimento-sistemas',
  'manutencao-eletronicos',
  'manutencao-celulares-tablets',
  'manutencao-notebooks-pcs',
  'manutencao-videogames',
  'infraestrutura-rede',
  'automacao-residencial',
  'energia-solar'
]; 